import { CompanyAdminSupportService } from '../../../service/company-admin-support.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-company-admin-support-popup-table-user-filters',
    templateUrl: './filters.component.html',
    styleUrls: ['./filters.component.scss'],
    standalone: false
})
export class CompanyAdminSupportPopupTableUserFiltersComponent implements OnInit, OnDestroy {
  /**
   * Select FormControl
   */
  selectFormControl = new UntypedFormControl(false);

  /**
   * Subscriptions
   */
  private subscriptions = new Subscription();

  constructor(private companyAdminSupportService: CompanyAdminSupportService) {}

  ngOnInit() {
    this.subscriptions.add(this.selectFormControl.valueChanges.subscribe((_) => this.selectUpdate()));
    this.subscriptions.add(this.companyAdminSupportService.selectedAdminsEmails$.subscribe((_) => this.checkSelectedUsers()));
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  /**
   * Select Update
   */
  private selectUpdate(): void {
    this.selectFormControl.value
      ? this.companyAdminSupportService.selectCompanyAdminsEmails()
      : this.companyAdminSupportService.unselectCompanyAdminsEmails();
  }

  /**
   * Check selected users
   */
  private checkSelectedUsers(): void {
    if (this.companyAdminSupportService.allCompanyAdminsSelected && !this.selectFormControl.value) {
      this.selectFormControl.patchValue(true, { emitEvent: false });
    } else if (!this.companyAdminSupportService.allCompanyAdminsSelected && this.selectFormControl.value) {
      this.selectFormControl.patchValue(false, { emitEvent: false });
    }
  }
}
